import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Reveal, GoldRule, Photo } from "@/components/Shared";
import { HairHero, HairBreadcrumb, HairBand, HairEyebrow, HairHeading, HairCTABand } from "@/components/HairShared";
import { StickyCTA } from "@/components/Landing";
import { OFFERS } from "@/data/landing";
import { JOURNAL_POSTS } from "@/data/content";
import { PHOTOS } from "@/data/photos";
import { HAIR_BREADCRUMBS, HAIR_HERO, HAIR_JOURNAL_SLUGS } from "@/data/hair";

const HairJournal = () => {
  const posts = HAIR_JOURNAL_SLUGS.map((s) => JOURNAL_POSTS.find((p) => p.slug === s)).filter(Boolean);
  const crumbs = HAIR_BREADCRUMBS.child("Journal", "/hair/journal");
  return (
    <>
      <SEO
        title="Hair Journal — Understanding Hair Loss | Lumière Hair Clinic"
        description="Plain-language articles on how hair grows, the Norwood scale and hair loss in women — written by the doctors at Lumière Hair Clinic, Cottesloe."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.name, item: `https://www.lumiereaesthetics.com.au${c.to}` })),
        }}
      />
      <HairHero eyebrow="Lumière Hair Clinic · Journal" title="Understand your hair first." standfirst="Three articles to begin with, written to be read before an assessment — not instead of one." offer={OFFERS.hair} image={HAIR_HERO.roomDetail} form={false} tall={false} testId="hair-journal-hero" />
      <HairBreadcrumb items={crumbs} />

      <HairBand testId="hair-journal-list">
        <Reveal className="mb-12">
          <HairEyebrow className="mb-3">Articles</HairEyebrow>
          <HairHeading>From the doctors, in plain language.</HairHeading>
          <GoldRule className="mt-6" />
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.1}>
              <Link to={`/journal/${post.slug}`} data-testid={`hair-journal-card-${post.slug}`} className="card-float block overflow-hidden group h-full">
                <Photo photo={PHOTOS[post.photo]} className="aspect-[16/10]" width={800} />
                <div className="p-7">
                  <HairEyebrow>{post.category}</HairEyebrow>
                  <h3 className="text-ink mt-2 group-hover:text-gold transition-colors duration-300">{post.title}</h3>
                  <p className="text-ink/70 text-sm mt-2 leading-relaxed">{post.excerpt}</p>
                  <p className="text-soft-grey text-xs mt-4">{post.byline}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <p className="text-soft-grey text-sm mt-12 max-w-2xl leading-relaxed" data-testid="hair-journal-more-note">
          Further articles are added as they are clinically signed off. The full practice journal is at <Link to="/journal" className="text-deep-sea hover:text-gold transition-colors duration-300">lumiereaesthetics.com.au/journal</Link>.
        </p>
      </HairBand>

      <StickyCTA practitioner="Dr Kristy Truong" hair />
      <HairCTABand />
    </>
  );
};

export default HairJournal;
